import { cn } from "@/lib/utils";
import React from "react";

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

export const Section = ({
  children,
  className,
  id,
  ...props
}: SectionProps) => {
  return (
    <section
      id={id}
      className={cn(
        "w-full max-w-7xl mx-auto px-0 sm:px-6 py-6 md:py-24 relative first:pt-6 md:first:pt-0",
        className
      )}
      {...props}
    >
      {/* Vertical Dividers */}
      <div className="absolute inset-y-0 left-0 w-px bg-border/50 border-l border-dashed border-border/30 hidden lg:block" />
      <div className="absolute inset-y-0 right-0 w-px bg-border/50 border-r border-dashed border-border/30 hidden lg:block" />

      {children}
    </section>
  );
};
